/* eslint-disable react/function-component-definition */
/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from 'react';
import { Link } from 'gatsby';

import { useState } from 'react';
import Header from './header';
import './layout.scss';
import Footer from './footer';
import { LOGOS, HEADER_MENU } from '../utils/consts';
import Button from './Button/Button';
import { ConsentForm } from './cookie-consent/ConsentForm';

const LayoutWrapper = ({ children }) => {
  const [isMenuActive, setMenuActive] = useState(false);

  const toggleHeaderMenu = () => {
    setMenuActive((state) => !state);
  };

  return (
    <div>
      <div className='hidden lg:flex flex-row justify-between items-center h-24 w-full lg:px-20 xl:px-24 2xl:px-36 pt-16 z-20 absolute top-0'>
        <Link
          to='/'
          className='flex flex-row items-center'
        >
          <img
            alt='Logo text'
            src={LOGOS.logoTextWhite}
            className='object-contain h-40'
          />
        </Link>
        <nav>
          <ul className='h-full w-full flex flex-row gap-6 justify-end items-center text-white text-base font-semibold uppercase leading-7'>
            {HEADER_MENU.map((menuItem) => (
              <li>
                <Link to={menuItem.path}>{menuItem.text}</Link>
              </li>
            ))}
            <li className='lg:ml-8'>
              <Button
                text='Contact'
                link='#contact_form__footer'
              />
            </li>
          </ul>
        </nav>
      </div>
      <div className='block lg:hidden w-full absolute top-0'>
        <nav>
          <div className={`header-menu ${isMenuActive ? 'open' : 'relative'}`}>
            <ul className='h-full w-full flex flex-col justify-center items-center font-bold text-white text-2xl gap-4 lg:gap-8 lg:text-5xl'>
              {HEADER_MENU.map((menuItem) => (
                <li>
                  <Link to={menuItem.path}>{menuItem.text}</Link>
                </li>
              ))}
            </ul>
          </div>
        </nav>
        <Header toggleHeaderMenu={toggleHeaderMenu} />
      </div>
      <div>
        <main>{children}</main>
        <ConsentForm />
        <Footer />
      </div>
    </div>
  );
};

export default LayoutWrapper;
